var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { FilespaceStatus } from '@lucidlink/dto/validation';
import { DEFAULT_STALE_INTERVAL, RefetchIntervals } from '#constants';
import { useAuthProvider, useLucidSdk } from '#context';
import { FilespacesKeyFactory } from '../../query-key-factories';
// The filespace will also be updated upon an update of the data
// from the useFilespaceListByWorkspaceId.ts hook
export const useFilespaceById = (workspaceId, filespaceId) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const { currentUser } = useAuthProvider();
    const queryClient = useQueryClient();
    const query = useQuery({
        queryKey: FilespacesKeyFactory.exact(workspaceId, filespaceId),
        queryFn: async () => {
            const result = await lucidSdk
                .workspaceClient(workspaceId)
                .getFilespace(filespaceId);
            // Update the cached data for this specific Filespace
            // in the list of all Filespaces in the current Workspace
            const allFilespacesData = queryClient.getQueryData(FilespacesKeyFactory.byWorkspace(workspaceId));
            const updatedFilespacesData = allFilespacesData.map((filespace) => {
                if (filespace.id === filespaceId) {
                    return result;
                }
                return filespace;
            });
            queryClient.setQueryData(FilespacesKeyFactory.byWorkspace(workspaceId), updatedFilespacesData);
            return result;
        },
        enabled: Boolean(currentUser?.emailVerified && workspaceId && filespaceId),
        refetchInterval: ({ state }) => {
            return [
                FilespaceStatus.SETUP_IN_PROGRESS,
                FilespaceStatus.SUSPEND_IN_PROGRESS,
                FilespaceStatus.UNSUSPEND_IN_PROGRESS,
            ].includes(state.data?.status)
                ? RefetchIntervals.xs
                : false;
        },
        staleTime: DEFAULT_STALE_INTERVAL,
        networkMode: 'always',
    });
    return { query };
};
_react_refresh_temp_1(useFilespaceById, "h8W7PdhpyNfXcix92fBk0Ao+8JA=", false, () => [useLucidSdk, useAuthProvider, useQueryClient, useQuery]);
